import React, { useEffect, useRef, useState } from 'react'
import { useMutation, gql } from '@apollo/client'
import { adminUpdateRating, deleteRating, createLike, createComment, deleteLike, updateRating } from '../../graphql/mutations'
import { Modal, Carousel, Collapse } from 'react-bootstrap'
import { cherryRed } from '../../constants/colors'
import CoconutIcon from '../rmp/CoconutIcon'
import styled from 'styled-components'
import Storage from '@aws-amplify/storage'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretLeft, faCaretRight, faComment, faHeart, faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons'

import { timeSince } from "../../helpers/dates"
import { userIsAdmin, useUser } from '../../helpers/user'
import { rmpToastError } from '../RMPToasts/rmptoasts'
import ProfPic from './profpic'
import { isMobile } from 'react-device-detect'
import { stockPini } from '../../constants/links'


const Styles = styled.div`
    background: ${({ piniAdjacent }) => piniAdjacent ? '#fff8e1' : 'white'};
    border-radius: 12px;
    box-shadow: ${({ piniAdjacent }) => piniAdjacent
        ? '0 0 0 2px #f9a825, 0 4px 18px rgba(249,168,37,0.22)'
        : '0 2px 8px rgba(0,0,0,0.07)'};
    border: ${({ piniAdjacent }) => piniAdjacent ? '2px solid #f9a825' : 'none'};
    margin-bottom: 14px;
    overflow: hidden;
    cursor: pointer;
    transition: box-shadow 0.2s, transform 0.2s;

    :hover {
        box-shadow: ${({ piniAdjacent }) => piniAdjacent
            ? '0 0 0 3px #f9a825, 0 8px 28px rgba(249,168,37,0.30)'
            : '0 6px 20px rgba(0,0,0,0.13)'};
        transform: translateY(-2px);
    }

    .card-body {
        padding: 14px 20px 8px;
    }

    .title {
        font-size: 1.15em;
        font-weight: bold;
    }

    .footer {
        border-top: 1px solid #f0f0f0;
        padding: 8px 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    p.description {
        overflow-wrap: break-word;
        color: #555;
        margin-bottom: 8px;
    }

    .icon {
        cursor: pointer;
        color: #bbb;
        transition: color 0.15s;
    }

    .liked {
        color: ${cherryRed};
    }

    .action-group {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 4px 10px;
        border-radius: 8px;
        cursor: pointer;
        color: #888;
        font-size: 0.95em;
        transition: background 0.15s, color 0.15s;
        :hover {
            background: #fff0f0;
            color: ${cherryRed};
        }
    }

    .action-group.liked {
        color: ${cherryRed};
    }
`
export default function RatingFeedRating({ rating, expand, setExpand }) {
    const { user } = useUser()
    const commentRef = useRef(null)
    const [editing, setEditing] = useState(false)
    const [deleteThisRating] = useMutation(gql(deleteRating), {
        refetchQueries: ['GetRatingsByDate']
    })
    const [editRating] = useMutation(gql(updateRating), {
        refetchQueries: ['GetRatingsByDate']
    })
    const [adminEditRating] = useMutation(gql(adminUpdateRating), {
        refetchQueries: ['GetRatingsByDate']
    })
    const [addLike] = useMutation(gql(createLike), {})
    const [removeLike] = useMutation(gql(deleteLike), {
        update(cache, { data: { createLike }}) {
            // cache.modify({
            //     fields: {
            //         Like(existing, { readField }) {
            //             console.log(existing)
            //             return existing
            //         },
            //         Rating(existing, { readField }) {
            //             console.log(existing)
            //             return existing
            //         },
            //         Ratings(existing, { readField }) {
            //             console.log(existing)
            //             return existing
            //         },
            //         getRatingsByDate(existing, { readField }) {
            //             console.log(existing)
            //             return existing
            //         },
            //     },
            // });        
        }
    })

    if (!user) return null
    const isAdmin = userIsAdmin(user)
    const canEdit = rating.owner == user.username
    const canDelete = isAdmin || canEdit

    const handleDelete = () => {
        if (!canDelete) {
            rmpToastError('Not authorized to delete')
        }
        if (window.confirm('Are you sure you want to delete this rating?')) {
            deleteThisRating({ variables: { input: { id: rating.id }}})
        }
    }


    const likes = rating.likes.items
    const userLikes = likes.filter(l => l.owner == user.username)    
    const isLiked = userLikes.length > 0
    const handleToggleLike = () => {
        if (isLiked) {
            userLikes.forEach(l => {
                removeLike({ variables: { input: { id: l.id }}})
            })
        } else {
            addLike({ variables: { input: { ratingID: rating.id }}})
        }
    }


    const comments = rating.comments.items

    const isPiniAdjacent = !!rating.is_pini_adjacent
    return <Styles piniAdjacent={isPiniAdjacent} onClick={() => setExpand(true)}>
        {isPiniAdjacent && <div style={{
            background: '#f9a825',
            color: '#fff',
            fontWeight: 'bold',
            textAlign: 'center',
            padding: '6px 12px',
            fontSize: '0.85em',
            letterSpacing: '0.04em',
        }}>
            ⚠️ WARNING: THIS IS A PINI ADJACENT RATING ⚠️
        </div>}
        <div className='card-body'>
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                <ProfPic username={rating.owner}/>
                <small style={{paddingLeft: '10px', color: '#888'}}>
                    {rating.owner} • {timeSince(rating.createdAt)} ago
                </small>
            </div>
            <div style={{textAlign: 'center'}}>
                <div className='title'>{rating.title}</div>
                <Nuts nuts={rating.overall}/>
                <p className='description'>{!!rating.description ? `"${rating.description}"` : <em>No description</em>}</p>
                <PiniImgs imgKeys={rating.imgKeys}/>
            </div>

            <Collapse in={expand}>
                <div>
                    <ExpandedRFR rating={rating} commentRef={commentRef}/>
                </div>
            </Collapse>
        </div>

        <div className='footer' onClick={e => e.stopPropagation()}>
            <div style={{flex: 1}}>
                {expand && <a href=""
                    style={{fontSize: '0.8em', color: '#aaa', textDecoration: 'none'}}
                    onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        setExpand(false)
                    }}>
                    Minimize
                </a>}
            </div>
            <div style={{display: 'flex', gap: '4px'}}>
                <span className='action-group'
                    onClick={e => {
                        e.stopPropagation()
                        setExpand(true)
                        setTimeout(() => commentRef.current.focus(), 500)
                    }}>
                    <FontAwesomeIcon icon={faComment}/>
                    {comments.length}
                </span>
                <span className={`action-group ${isLiked ? 'liked' : ''}`}
                    onClick={e => {
                        handleToggleLike()
                        e.stopPropagation()
                    }}>
                    <FontAwesomeIcon icon={faHeart}/>
                    {likes.length}
                </span>
            </div>
            <div style={{flex: 1, textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px'}}>
                {canDelete && <FontAwesomeIcon
                    className='icon'
                    icon={faPencilAlt}
                    onClick={e => { e.stopPropagation(); setEditing(true) }}
                    style={{color: '#ccc'}}
                />}
                {canDelete && <FontAwesomeIcon
                    className='icon'
                    icon={faTrash}
                    onClick={e => { e.stopPropagation(); handleDelete() }}
                    style={{color: '#ccc'}}
                />}
            </div>
        </div>
        {editing && <EditRatingModal
            rating={rating}
            onSave={input => {
                if (isAdmin && rating.owner !== user.username) {
                    adminEditRating({ variables: { id: rating.id, ...input } })
                } else {
                    editRating({ variables: { input: { id: rating.id, ...input } } })
                }
                setEditing(false)
            }}
            onClose={() => setEditing(false)}
        />}
    </Styles>

}


const EditRatingModal = ({ rating, onSave, onClose }) => {
    const [title, setTitle] = useState(rating.title)
    const [description, setDescription] = useState(rating.description || '')
    const [overall, setOverall] = useState(rating.overall)
    const [restaurantName, setRestaurantName] = useState(rating.restaurantName || '')
    const [isPiniAdjacent, setIsPiniAdjacent] = useState(!!rating.is_pini_adjacent)

    const handleSubmit = e => {
        e.preventDefault()
        if (overall < 1) { return }
        onSave({ title, description, overall, restaurantName, is_pini_adjacent: isPiniAdjacent })
    }

    return <Modal show onHide={onClose} onClick={e => e.stopPropagation()}>
        <Modal.Header closeButton><strong>Edit Rating</strong></Modal.Header>
        <Modal.Body>
            <form onSubmit={handleSubmit}>
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontWeight: 'bold', display: 'block', marginBottom: '4px'}}>Title</label>
                    <input
                        style={{width: '100%', border: '1px solid #ddd', borderRadius: '6px', padding: '6px 10px', fontFamily: 'inherit'}}
                        value={title}
                        onChange={e => setTitle(e.target.value)}
                    />
                </div>
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontWeight: 'bold', display: 'block', marginBottom: '4px'}}>Bar Name</label>
                    <input
                        style={{width: '100%', border: '1px solid #ddd', borderRadius: '6px', padding: '6px 10px', fontFamily: 'inherit'}}
                        value={restaurantName}
                        onChange={e => setRestaurantName(e.target.value)}
                    />
                </div>
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontWeight: 'bold', display: 'block', marginBottom: '4px'}}>Overall Rating</label>
                    <Nuts nuts={overall} highlight={cherryRed} showRange={true}/>
                    <div style={{display: 'flex', gap: '6px', marginTop: '6px'}}>
                        {[1,2,3,4,5].map(n => <button key={n} type='button'
                            onClick={() => setOverall(n)}
                            style={{
                                padding: '4px 10px', borderRadius: '6px', cursor: 'pointer', fontFamily: 'inherit',
                                background: overall === n ? cherryRed : '#f5f5f5',
                                color: overall === n ? 'white' : '#333',
                                border: `1px solid ${overall === n ? cherryRed : '#ddd'}`,
                            }}>
                            {n}
                        </button>)}
                    </div>
                </div>
                <div style={{marginBottom: '12px'}}>
                    <label style={{fontWeight: 'bold', display: 'block', marginBottom: '4px'}}>Description</label>
                    <textarea
                        style={{width: '100%', border: '1px solid #ddd', borderRadius: '6px', padding: '8px 10px', fontFamily: 'inherit', resize: 'none'}}
                        rows={3}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                    />
                </div>
                <div style={{marginBottom: '16px'}}>
                    <label style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}}>
                        <input type='checkbox' checked={isPiniAdjacent} onChange={e => setIsPiniAdjacent(e.target.checked)} style={{accentColor: '#f9a825'}}/>
                        <span>Pini adjacent rating</span>
                    </label>
                </div>
                <div style={{display: 'flex', justifyContent: 'flex-end', gap: '8px'}}>
                    <button type='button' onClick={onClose}
                        style={{padding: '6px 16px', borderRadius: '6px', border: '1px solid #ddd', background: 'white', cursor: 'pointer', fontFamily: 'inherit'}}>
                        Cancel
                    </button>
                    <button type='submit'
                        style={{padding: '6px 16px', borderRadius: '6px', border: 'none', background: cherryRed, color: 'white', cursor: 'pointer', fontFamily: 'inherit'}}>
                        Save
                    </button>
                </div>
            </form>
        </Modal.Body>
    </Modal>
}

const Nuts = ({ nuts, outOf=5, showRange=true, height, highlight=cherryRed }) => {
    if (showRange) {
        const n = [...Array(outOf)]
        return n.map((_, i) => 
            <CoconutIcon key={i} 
                circleHighlight={i<nuts ? highlight : null} 
                height={height} 
                color={i < nuts ? 'white' : 'black'}
            />)
    } else {
        const n = [...Array(nuts)]
        return n.map((_, i) => <CoconutIcon key={i} circleHighlight={highlight} height={height} color='white'/>)
    }
}


const shimmer = `
    @keyframes shimmer {
        0% { background-position: -600px 0; }
        100% { background-position: 600px 0; }
    }
`

const ImgStyles = styled.div`
    ${shimmer}
    cursor: pointer;
    text-align: center;

    .container {
        padding: 0;
        border-radius: 10px;
        display: inline-block;
        position: relative;
        text-align: center;
        color: #ddd;
        max-height: 300px;
        max-width: ${props => props.maxWidth ? props.maxWidth : '250px'};
        overflow: hidden;
    }

    .placeholder {
        width: 240px;
        height: 240px;
        border-radius: 10px;
        background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
        background-size: 600px 100%;
        animation: shimmer 1.4s infinite linear;
    }

    .bottom-right {
        position: absolute;
        bottom: 5px;
        right: 20px;
        font-size: 40px;
        font-style: italic;
        color: white;
        background: ${cherryRed+'77'};
        border-radius: 40%;
    }

    .pimg {
        width: 100%;
        height: 100%;
        :hover {
            opacity: 0.8;
        }
    }
`
const ModalStyles = styled.div`
    background: #333;
    .carousel-control {
        color: ${cherryRed};
        font-size: 60px;
    }
`
const PiniImgs = ({ imgKeys }) => {
    const [show, setShow] = useState(false)
    const [imSrcs, setImSrcs] = useState([]) // list of objects { key, url }
    const [urlsLoading, setUrlsLoading] = useState(imgKeys.length > 0)
    const [loadedKeys, setLoadedKeys] = useState(new Set())
    useEffect(() => {
        if (imgKeys.length > 0) {
            (async () => {
                const newSrcs = []
                for (const k of imgKeys) {
                    const url = await Storage.get(k, { level: 'public', expires: 604800 })
                    newSrcs.push({ key: k, url })
                }
                setImSrcs(newSrcs)
                setUrlsLoading(false)
            })()
        }
    }, [imgKeys])

    if (imgKeys.length == 0) return <></>

    var numToShow = isMobile ? 1 : 2
    const maxWidth = `${80/numToShow}%`
    const numPlaceholders = Math.min(imgKeys.length, numToShow)

    // Phase 1: S3 URLs not yet fetched — show shimmer placeholders
    if (urlsLoading) {
        return <ImgStyles maxWidth={maxWidth}>
            <div>
                {[...Array(numPlaceholders)].map((_, i) => (
                    <div className='container' key={i}>
                        <div className='placeholder'/>
                    </div>
                ))}
            </div>
        </ImgStyles>
    }

    const imToShow = imSrcs.slice(0, numToShow)

    return <>
        <ImgStyles maxWidth={maxWidth}>
            <div>
                {imToShow.map(i => <div className='container' key={i.url}>
                    <center>
                    {!loadedKeys.has(i.key) && <div className='placeholder'/>}
                    <img
                        className="pimg"
                        style={{ display: loadedKeys.has(i.key) ? 'block' : 'none' }}
                        onLoad={() => setLoadedKeys(prev => new Set([...prev, i.key]))}
                        onClick={e => { e.stopPropagation(); setShow(true) }}
                        src={i.url}
                    />
                    </center>
                    {imSrcs.length > numToShow && <div className='bottom-right'>
                        +{imSrcs.length - numToShow}
                    </div>}
                </div>)}
            </div>
        </ImgStyles>
        <Modal size='lg' show={show} onHide={() => setShow(false)} onClick={e => e.stopPropagation()}>
            <ModalStyles>
            <Carousel
                prevIcon={<FontAwesomeIcon className='carousel-control left' icon={faCaretLeft}/>}
                nextIcon={<FontAwesomeIcon className='carousel-control right' icon={faCaretRight}/>}
            >
            {imSrcs.map(src => <Carousel.Item key={src.key}>
                <img
                    src={src.url}
                    alt="Pini image"
                    width='100%'
                />
            </Carousel.Item>)}
            </Carousel>
            </ModalStyles>
        </Modal>
    </>
}


const BRStyles = styled.div`
    margin-top: 10px;
    font-size: 0.9em;
    table.breakdowns {
        text-align: center;
        tr {
            border-bottom: 1px solid #ddd;
        }
        th {
            padding: 0 10px;
        }
        td {
            padding: 0 10px;
        }
    }
    table.comment-header {
        width: 100%;
    }
    .comments-container {
        width: 95%;
        margin: auto;
    }
    .inner-comments {
        width: 95%;
        margin: auto;
    }
    .comment-box {
        padding: 8px 0;
        border-bottom: 1px solid #f0f0f0;
        :last-child {
            border-bottom: 0;
        }
    }
    .comment-content {
        padding-left: 10px;
        margin-top: 2px;
        font-size: 0.95em;
        color: #333;
    }
    .comment-form {
        margin-top: 10px;
        display: flex;
        align-items: stretch;
    }
    textarea.comment-input {
        flex: 1;
        border-radius: 8px 0 0 8px;
        border: 1px solid #e0e0e0;
        border-right: none;
        padding: 8px 10px;
        font-family: inherit;
        font-size: 0.9em;
        resize: none;
        transition: border-color 0.2s;
        :focus {
            outline: none;
            border-color: #aaa;
        }
    }
    button.comment-submit {
        border: 1px solid #e0e0e0;
        border-radius: 0 8px 8px 0;
        background: white;
        padding: 0 12px;
        cursor: pointer;
        color: #aaa;
        transition: background 0.15s, color 0.15s;
        :hover:not(:disabled) {
            background: ${cherryRed};
            border-color: ${cherryRed};
            color: white;
        }
        :disabled {
            cursor: default;
            opacity: 0.4;
        }
    }
`
const ExpandedRFR = ({ rating, commentRef }) => {
    const [show, setShow] = useState(false)
    const [content, setContent] = useState('')
    const likedBy = rating.likes.items.map(l => l.owner)
    const likesToShow = 3
    var comments = [...rating.comments.items]
    comments.sort((a,b) => {
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1
        return 1
    })
    const [addComment] = useMutation(gql(createComment), {
        onCompleted: args => {
            setContent('')
        }
    })

    const handleSubmitComment = e => {
        e.preventDefault()
        const content = e.target.comment.value
        if (!content.length) return
        addComment({ variables: { input: { ratingID: rating.id, content } }})
    }

    return <BRStyles>
    <center>
    <table className='breakdowns'>
    <tbody>
        {rating.breakdownRatings.items.map(br => <tr key={br.name}>
            <th>{br.name}</th>
            <td>
                <Nuts nuts={br.value} height='25px' highlight={cherryRed+'aa'}/>
                {!!br.notes && <div className='notes'>"{br.notes}"</div>}
            </td>
        </tr>)}
    </tbody>
    </table>

    <br></br>
    {likedBy.length > 0 ? <>
        Liked by {likedBy.slice(0, likesToShow).join(', ')}
        {' '} 
        <a href='' onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            setShow(true)              
        }}>
            {likedBy.length > likesToShow ? <>
                + {likedBy.length - likesToShow} more 
            </>: <>See all</>}
        </a> 
    </> : <em>No likes</em>}
    </center>
    <div className='comments-container'>
        <b>Comments</b>
        <div className='inner-comments'>
            {comments.length == 0 && <div><em>No comments</em></div>}
            {comments.map(c => <div key={c.id} className='comment-box'>
                <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                    <ProfPic username={c.owner} height='30px' width='30px'/>
                    <small style={{color: '#888'}}>
                        {c.owner} • {timeSince(c.createdAt)} ago
                    </small>
                </div>
                <div className='comment-content'>{c.content}</div>
            </div>)}
        </div>
        <form onSubmit={handleSubmitComment} className='comment-form'>
            <textarea className='comment-input'
                ref={commentRef}
                name='comment'
                placeholder='Add a comment...'
                rows={2}
                onClick={e => e.stopPropagation()}
                value={content}
                onChange={e => setContent(e.target.value)}
            />
            <button className='comment-submit' type='submit' disabled={content.length == 0} onClick={e => e.stopPropagation()}>
                <img src={stockPini} height='20px'/>
            </button>
        </form>
    </div>
    <Modal show={show} onHide={() => setShow(false)}>
        <Modal.Header closeButton>
            {rating.title} Likes
        </Modal.Header>
        <Modal.Body>
            <div>
                {likedBy.map(l => <div key={l}>
                    <table><tbody>
                        <tr>
                            <td><ProfPic username={l} /></td>
                            <td>{l}</td>
                        </tr>
                    </tbody></table>
                </div>)}
            </div>
        </Modal.Body>
    </Modal>
    </BRStyles>
}